<template>
  <!-- App Header -->
  <SideHeader :to="'/'" />
  <!-- * App Header -->

  <!-- App Capsule -->
  <div id="refresh-container">
    <div class="pt-55">
<!-- loader -->
      <div v-if="loading" id="loader">
          <div class="spinner-border text-primary" role="status"></div>
      </div>
      <div v-else style="background-color: white">

        <!-- <FixLimited v-if="freeCalls != 'false' && freeCalls >= 0 && freeCalls <= 6" :freeCalls="freeCalls" /> -->

        <div class="section" :class="[
            { 'mt-3 mb-3': index !== 0 },
            { 'mt-4 mb-3': index == 0 },
            { 'pt-45': index == 0 && freeCalls != 'false' && freeCalls > 6 }
          ]" v-for="(cargo, index) in cargos" :key="index.id">
          <CardView :cargo="cargo" />
        </div>
        <!-- <p class="alert alert-warning text-center" v-if="mode == 0 && loadingOff == 0">
          لطفا منتظر بمانید...
        </p> -->
        <button @click="nextLoadCargo()" class="btn btn-success btn-block btn-lg" v-if="mode == 1 && loadingNext == 0">
          نمایش بار های بیشتر کلیک کنید...
        </button>
        <button class="btn btn-warning btn-lg btn-block" type="button" disabled="" v-if="loadingNext == 1">
          <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
          درحال بارگذاری ...
        </button>
      </div>
    </div>
    <!-- * App Header -->



    <a href="#" class="button goTop show">
      <ion-icon name="arrow-up-outline"></ion-icon>
    </a>
  </div>
  <!-- * App Capsule -->

  <!-- App Bottom Menu -->
  <!-- <Footer v-show="isLoggedIn" /> -->

  <!-- * App Bottom Menu -->

  <!-- App Sidebar -->

  <!-- * App Sidebar -->
</template>
<script>
// import Placeholder from "@/components/Placeholder.vue";
import CardView from "@/views/cargo/components/CardView.vue";
import router from "@/router";
import axios from "axios";
import Swal from "sweetalert2";
import SideHeader from "@/components/SideHeader.vue";
import PullToRefresh from "pulltorefreshjs";
// import FixLimited from "@/components/FixLimited.vue";

export default {
  name: "Master",
  components: {
    CardView,
    // Placeholder,
    SideHeader,
    // FixLimited
    // Footer
  },
  data() {
    return {
      mode: 0,
      loadingOff: 0,
      freeCalls: 'false',
      cargos: [],
      show: false,
      loading: false,
      loadingNext: 0,
      ptrInstance: null,
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }
    };
  },
  methods: {
    initPullToRefresh() {
      if (this.ptrInstance) {
        this.ptrInstance.destroy();
      }
      this.ptrInstance = PullToRefresh.init({
        mainElement: '#refresh-container',
        onRefresh: () => this.getInitialCargos()
      });
    },
    getInitialCargos() {
      this.loading = true;
      axios.get(`https://xpanel.s-bar.ir/api/driver/getNewLoadForDriver/0`, this.axiosConfig)
        .then((response) => {
          this.loading = false;

          if (this.$route.query.token != undefined) {
            axios.patch(`https://xpanel.s-bar.ir/api/driver/saveMyFireBaseToken`, {
              token: this.$route.query.token
            }, this.axiosConfig);
          }

          localStorage.setItem("tel", response.data.data.Tel);
          if (response.data.data.result == 0) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: response.data.data.message,
              showConfirmButton: true,
              confirmButtonText: "تغییر ناوگان",
              // timer: 2000,
            }).then((result) => {
              if (result.isConfirmed) {
                router.push({ name: 'profile' })
              }
            });
          }
          this.cargos = response.data.data.loads;
          const savedPosition = localStorage.getItem('scrollPosition');
          if (savedPosition) {
            setTimeout(() => {
              window.scrollTo(0, savedPosition);
            }, 250);
            this.loading = false;
          } else {
            this.loading = false;
          }
          this.freeCalls = response.data.data.freeCalls;
          this.getNextCargo();

          // console.log(this.cargos);
        })
        .catch((error) => {
          if (error.status === 401) {
            Swal.fire({
              title: "راننده محترم!",
              text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
              icon: "error",
              confirmButtonColor: "#0099c9",
              confirmButtonText: "ورود مجدد!",
            }).then((result) => {
              if (result.isConfirmed) {
                Object.keys(localStorage).forEach((key) => {
                  if (!['version'].includes(key)) {
                    localStorage.removeItem(key);
                  }
                });
                router.push({ name: 'login' })
              }
            });
          }
        });
    },
    getNextCargo() {
      axios.get(`https://xpanel.s-bar.ir/api/driver/getNewLoadForDriver/${this.cargos[this.cargos.length - 1].id}`, this.axiosConfig)
        .then((res) => {
          // console.log(res.data.data.loads);
          if (res.data.data.length == 0) {
            this.mode = 2;
          }
          this.cargos.push(...res.data.data.loads);
          this.mode = 1;
        });
      // console.log(this.cargos[this.cargos.length - 1].id);
    },
    nextLoadCargo() {
      this.loadingNext = 1;
      axios
        .get(`https://xpanel.s-bar.ir/api/driver/getNewLoadForDriver/${this.cargos[this.cargos.length - 1].id}`, this.axiosConfig)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.data.length == 0) {
            this.mode = 0;
            this.loadingOff = 1;
          }
          this.cargos.push(...res.data.data.loads);
          this.loadingNext = 0;
        })
        .catch((error) => {
          // handle error
          console.log(error);
          this.loadingNext = 0;
          this.mode = 0;
          console.log(this.loadingNext, this.mode);
        });
    },
    saveScrollPosition() {
      localStorage.setItem('scrollPosition', window.scrollY);
    },
  },
  beforeMount() {
    this.getInitialCargos();
  },
  mounted() {
    this.initPullToRefresh();
    // this.restoreScrollPosition();
    // window.addEventListener('beforeunload', this.saveScrollPosition);

  },
  beforeRouteLeave(to, from, next) {
    this.saveScrollPosition();
    next();
  },
  beforeUnmount() {
    if (this.ptrInstance) {
      this.ptrInstance.destroy();
    }
  }
};
</script>
<style>
.pt-45 {
  padding-top: 2rem !important;
}

#webpack-dev-server-client-overlay {
  display: none;
}
</style>